import { DeserializationUtils } from '../../utils/deserialization-utils';
import { BaseResource } from './base-resource';
import { LoyaltyPlanAward } from './loyalty-plan-award.model';
import { LoyaltySubscription } from './loyalty-subscription.model';

interface SubscriptionsPointsFactors {
  pointsFactorMultiplier: number;
  pointsPerDollar: number;
  subscriptionName: string;
}

export class LoyaltyPlan extends BaseResource {
  readonly id: string;
  readonly loyaltyPlanName: string;
  readonly needsLoyaltyCards: boolean;
  readonly hasLoyaltyCards: boolean;
  readonly needsGiftCards: boolean;
  readonly hasGiftCards: boolean;
  readonly needsName: boolean;
  readonly hasEmail: boolean;
  readonly needsEmail: boolean;
  readonly hasPhone: boolean;
  readonly needsPhone: boolean;
  readonly rules: LoyaltyRule[];
  readonly awards: LoyaltyPlanAward[];
  readonly closingAwardThreshold: number;
  readonly loyaltySubscriptions: LoyaltySubscription[];
  readonly subscriptionsPointsFactors?: SubscriptionsPointsFactors[];

  deserialize(input: any): this {
    return Object.assign(this, input, {
      awards: DeserializationUtils.deserializeChildren(input, 'awards', LoyaltyPlanAward),
    });
  }
}

export class LoyaltyRule {
  description: string;
  loyaltySubscription?: string;
}
